export const version = '1.0.8';
//# sourceMappingURL=version.js.map